import { IAttachmentFile } from "../../containers/Steps/Attachments";
import AttachmentContextProvider from "./AttachmentContext";

export interface IAttachmentContext {
    Attachments: IAttachmentFile[];
    RemoveAttachment: (file: IAttachmentFile) => void;
    UploadAttachments: (files: IAttachmentFile[]) => void;
    IsAttachmentsFinished: boolean;
    SetInitialAttachments: (files: IAttachmentFile[]) => void;
}

export interface IAttachmentContextProviderProps {
    AttachmentFolder: string;
    AttachmentEvents: IEmailAttachmentEvents;
    InitialAttachments: IAttachmentFile[];
    children: React.ReactNode;
}

export { AttachmentContextProvider };
